export const formatModuleListTitle = (listTitle, roleLabel) => {
  const title = String(listTitle || "").trim();
  const role = String(roleLabel || "").trim();
  if (!role || role.startsWith("(")) {
    return title;
  }
  if (!title) {
    return role;
  }
  return `${title} - ${role}`;
};

export const isCasePhaseTableField = (item = {}) =>
  item.field === "case_phase" || item.data_type === "phase";

export const CASE_PHASE_TABLE_FIELD = {
  id: "case_phase",
  field: "case_phase",
  is_in_bdd: false,
  data_type: "phase",
  type: "field",
  show_in_table: true,
  sort_in_table: true,
  style_in_table: "list-table-cell-xs",
  readmore_limit_table: "null",
  deleted: false,
  activated: true
};

export const prependCasePhaseField = (fields = []) => {
  const list = Array.isArray(fields) ? [...fields] : [];
  if (list.some((item) => isCasePhaseTableField(item))) {
    return list;
  }
  const phaseField = { ...CASE_PHASE_TABLE_FIELD };
  const idIndex = list.findIndex((item) => item.field === "id" && item.show_in_table !== false);
  if (idIndex === -1) {
    return [phaseField, ...list];
  }
  list.splice(idIndex, 0, phaseField);
  return list;
};

export const getModuleListFieldHeaderLabel = (item, t, moduleKey) => {
  if (isCasePhaseTableField(item)) {
    return t("flow.cmi.col.phase", "Fase");
  }
  return t(`${moduleKey}.short.${item.field}`);
};

export const countFlowListTableColumns = (listFields = [], flowSelectionEnabled = false) => {
  const fieldCount = (listFields || []).filter(
    (item) => item.show_in_table && item.data_type !== "buttons"
  ).length;
  return fieldCount + 1 + (flowSelectionEnabled ? 2 : 0);
};
